export const getShortName = (name, length) => {
    if(name && name.length > length) {
        return name.slice(0, length) + '... ' + name.slice(name.length-4)
    } else {
        return name;
    }
}